
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mdiCalendar } from '@mdi/js';
import SideNavSectionTitle from './SideNavSectionTitle.vue';
import DatePreview from '../ui/DatePreview.vue';
import { MyEventsMixin, AppHostnameMixin } from '../../mixins';
import * as Routes from '../../../types/constants/web_client_user.routes';
import { EventAdminRequiredRoles } from '../../../types/constants/event-admin';
import { BestAthletesEventModel } from '../../models/bestAthletesEvent';
import { hasRole } from '../../directives/v-require-role';


@Component({
	components: { DatePreview, SideNavSectionTitle },
})
export default class EventsNavItems extends Mixins(MyEventsMixin, AppHostnameMixin){
	mdiCalendar = mdiCalendar;
	EventAdminRequiredRoles = EventAdminRequiredRoles;
	@Prop({ default: false, type: Boolean }) mini: boolean;
	@Prop({ default: false, type: Boolean }) noAdmin: boolean;
	@Prop({ default: 3 }) limit: number;
	get RootEventDetailsRoute(): string{
		return `${Routes.AthleteProfilesManagement}${Routes.EventDetails}`
	}

	get MyEventsLimited(): BestAthletesEventModel[]{
		return this.MyEvents.slice(0, this.limit);
	}

	get NoEvents(): boolean{
		return this.MyEventsLimited.length === 0;
	}

	get ShowEvents(): boolean{
		if(this.AdminAppActive) return true;
		if(this.NoEvents === true){
			return false;
		}
		return this.NoEvents === false || this.EventAdminRequiredRoles.map(role => hasRole(role)).reduce((a,b) => a || b);
	}
}
